
import { Wrap } from "./Icons.style";
import { Text } from "./Icons.style";
import { Svg } from "./Icons.style";
import { Path } from "./Icons.style";
import { Circle } from "./Icons.style";
import { Relative } from "./Icons.style";
import { iconLib } from "./iconslib.jsx";
import { fontAwesomeIconSet } from "../components/Icons/fontAwesomeIconSet.js"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";


export const Icon = ({
  size = 25,
  szm = 15,
  szd = 25,
  color = "#fff",
  icon = "",
  className = "",
  style = {},
  pathStyle={},
  wrap = {},
  text = false,
  fontSize = "0.75rem",
  click = () => { },
  width = "unset",
  count = false,
  tick = false,
  isGrid = false,
  hide = false,
  children,
  isFaIcon,
  extraSvgAttributes,
  fontAswStyle,
  skipColorChange,
}) => {

  const svgAttributes = {
    className: className,
    style: style,
    viewBox: "0 0 1000 1000",
    width: `${style?.fontSize || '26px'}`,
    height: `${style?.fontSize || '26px'}`,
    ...extraSvgAttributes
  };
  const wrap_ = { onClick: click, width, style: wrap };
  const path_ = { fill: color, d: iconLib[icon], ...pathStyle };
  const text_ = { show: text, color, fontSize, children: text };
  const tick_ = { show: tick ? true : false, x: size - 15, y: -2 };
  const circ_ = { show: count, x: isGrid ?  size - 17 : size - 18 , y: -8 };

  if (hide) return false;
  
  // Guard against undefined icon prop
  if (!icon) {
    console.warn('Icon component rendered without valid icon prop:', { icon, isFaIcon });
    return null;
  }

 const iconBaseStyle = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  width: size,
  height: size,
};

const faIcon = fontAwesomeIconSet[icon];

return (
  <Wrap {...wrap_}>
    <Relative>
      {isFaIcon && faIcon ? (
        <FontAwesomeIcon
          icon={faIcon}
          className={className}
          color={color}
          style={{ fontSize: '24px', ...style }}
        />
      ) : (
        <Svg {...svgAttributes}>
          <Path fill={color} {...path_} />
        </Svg>
      )}

      <Circle {...circ_}>{count}</Circle>
      <Circle {...tick_}>{tick}</Circle>
      {children}
    </Relative>

    <Text {...text_} />
  </Wrap>
);
};
